export const DEFAULT_LOCALE_STATE = {
	locale: 'en-US',
	messages: undefined,
};
